// @flow
import React from 'react';
import H4 from '../H4';
import Img from "../Img";

import StyledZammadButton from './StyledZammadButton';

import imgSales from '../../assets/img/sales.svg';

const $ = window.$;

export class ZammadButton extends React.Component {
  componentDidMount() {
    this.$el = $(this.el);
    this.$el.ZammadForm({
      messageTitle: 'Sales Inquiry',
      messageSubmit: 'Submit',
      messageThankYou:
        "Thank you for your inquiry (#%s)! We'll contact you as soon as possible.",
      showTitle: true,
      modal: true,
    });
  }

  render() {
    return (
      <StyledZammadButton className="column">
        <a
          ref={el => (this.el = el)}
          className="zammad-button"
          id="sales-form"
        >
          <Img src={imgSales} />
          <div className="contact-text">
            <H4>I&apos;d like to work together</H4>
            <p>Speak to our sales team to find out how you can work with us</p>
          </div>
        </a>
      </StyledZammadButton>
    );
  }
}

export default ZammadButton;
